function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { createAssetValidator } from "./TLBaseAsset";
/** @internal */ export const videoAssetValidator = createAssetValidator("video", T.object({
    w: T.number,
    h: T.number,
    name: T.string,
    isAnimated: T.boolean,
    mimeType: T.string.nullable(),
    src: T.string.nullable()
}));
const Versions = {
    AddIsAnimated: 1,
    RenameWidthHeight: 2
};
/** @internal */ export const videoAssetMigrations = defineMigrations({
    currentVersion: Versions.RenameWidthHeight,
    migrators: {
        [Versions.AddIsAnimated]: {
            up: (asset)=>{
                return _object_spread_props(_object_spread({}, asset), {
                    props: _object_spread_props(_object_spread({}, asset.props), {
                        isAnimated: false
                    })
                });
            },
            down: (asset)=>{
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _asset_props = asset.props, { isAnimated } = _asset_props, rest = _object_without_properties(_asset_props, [
                    "isAnimated"
                ]);
                return _object_spread_props(_object_spread({}, asset), {
                    props: rest
                });
            }
        },
        [Versions.RenameWidthHeight]: {
            up: (asset)=>{
                const _asset_props = asset.props, { width, height } = _asset_props, others = _object_without_properties(_asset_props, [
                    "width",
                    "height"
                ]);
                return _object_spread_props(_object_spread({}, asset), {
                    props: _object_spread({
                        w: width,
                        h: height
                    }, others)
                });
            },
            down: (asset)=>{
                const _asset_props = asset.props, { w, h } = _asset_props, others = _object_without_properties(_asset_props, [
                    "w",
                    "h"
                ]);
                return _object_spread_props(_object_spread({}, asset), {
                    props: _object_spread({
                        width: w,
                        height: h
                    }, others)
                });
            }
        }
    }
});
